import { Controller } from "@hotwired/stimulus"

// Fills the "Abweichender Rechnungsempfänger" fields from the customer's
// Rechnungsadresse. Only empty fields would be ambiguous to merge, so the prefill
// overwrites everything the endpoint returns and leaves the rest untouched.
export default class extends Controller {
  static targets = [
    "name",
    "addition",
    "contactPersonName",
    "street",
    "postalCode",
    "city",
    "countryCode",
    "vatId",
    "email",
    "fallbackHint",
  ]
  static values = { url: String }

  async prefill() {
    if (!this.hasUrlValue || this.urlValue === "") return

    try {
      const response = await fetch(this.urlValue, {
        headers: { Accept: "application/json" },
      })
      if (!response.ok) return

      const data = await response.json()
      this.#assign("name", data.name)
      this.#assign("addition", data.addition)
      this.#assign("contactPersonName", data.contact_person_name)
      this.#assign("street", data.street)
      this.#assign("postalCode", data.postal_code)
      this.#assign("city", data.city)
      this.#assign("countryCode", data.country_code)
      this.#assign("vatId", data.vat_id)
      this.#assign("email", data.email)

      if (this.hasFallbackHintTarget) {
        this.fallbackHintTarget.classList.toggle("hidden", !data.fallback)
      }
    } catch {
      // Prefill is a convenience — a failed lookup leaves the form as typed.
    }
  }

  #assign(target, value) {
    if (!this[`has${target[0].toUpperCase()}${target.slice(1)}Target`]) return

    this[`${target}Target`].value = value || ""
  }
}
